export default __webpack_public_path__ + "static/media/news.21a2d43f.svg";